import { Directive, Input, TemplateRef } from '@angular/core';
import { BoschUiTableService } from '../bosch-ui-table.service';

@Directive({
  selector: '[boschUiHeaderRowDef]',
})
export class BoschUiHeaderRowDefDirective<DataType> {
  @Input() set boschUiHeaderRowDef(columns: string[]) {
    this.tableService.createHeaderRowCells(columns);

    this._rowDisplayColumns = columns;
  }

  get headerRowDisplayColumns(): string[] {
    return this._rowDisplayColumns;
  }

  private _rowDisplayColumns: string[] = [];

  constructor(public templateRef: TemplateRef<DataType>, private tableService: BoschUiTableService<DataType>) {}
}
